import i18next from 'i18next';
import i18NextHttpBackend from 'i18next-http-backend';
import { POLARIS_I18NEXT_RESOURCES } from 'polaris-translation/polaris-languages';
import { initReactI18next } from 'react-i18next';
import { BUILD_ID, ENV } from '../build-id.mjs';

const TRANSLATE_PATH = import.meta.env.VITE_TRANSLATE_PATH;

i18next
    .use(initReactI18next)
    .use(i18NextHttpBackend)
    .init({
        // debug: true,
        lng: 'en',
        fallbackLng: 'en',
        defaultNS: 'translation',
        // The `polaris` namespace ships bundled. `partialBundledLanguages` is required: without it,
        // setting `resources` makes i18next skip the backend entirely and `translation` never loads.
        resources: POLARIS_I18NEXT_RESOURCES,
        partialBundledLanguages: true,
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: ['production', 'development'].includes(import.meta.env.VITE_APP_ENV)
                ? `${import.meta.env.VITE_BUCKET_BUILD_ASSETS_URL}/${ENV}/${BUILD_ID}/locales/{{lng}}/{{ns}}.json`
                : `${TRANSLATE_PATH ? TRANSLATE_PATH : ''}/locales/{{lng}}/{{ns}}.json`,
        },
    });

export default i18next;
